// Configuration centralisée pour les URLs de l'API
// Utiliser des URLs statiques pour éviter les problèmes avec les variables d'environnement

const config = {
  API_URL: "https://trad-legacy.api.mangas.io",
  FRONTEND_URL: "https://trad-legacy.mangas.io",
};

export default config;
